import React, { Component } from 'react';
import PageTitle from '@/components/PageTitle';
import { CreditCardOutlined, DollarOutlined, LineChartOutlined, ReloadOutlined, ShoppingCartOutlined, UserAddOutlined, UserOutlined } from '@ant-design/icons';
import { Typography, Card, Row, Col, DatePicker, Divider, Spin, Button } from 'antd';
import { connect } from 'react-redux';
import qs from 'qs';
import _ from 'lodash';
import { cleanObject } from '@/utils/helpers';
import moment from 'moment';
import { getRevenueStatistics } from '@/redux/actions/statisticsActions';
import { getBranchActive } from '@/redux/actions/BranchActions';
import FilterableMultiSelect from '@/components/FilterableMultiSelect';

const { Title, Text } = Typography;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/revenue-report',
        breadcrumbName: 'Doanh thu & doanh số',
    }
];

const { RangePicker } = DatePicker;

class RevenueReport extends Component {

    constructor() {
        super();
        this.state = {
            isLoading: false
        }
    }

    componentDidMount() {
        let query = qs.parse(this.props.location.search.slice(1));

        // Nếu chưa có start_date và end_date thì gán ngày hôm nay
        if (!query.start_date || !query.end_date) {
            const today = moment().format('YYYY-MM-DD');
            query.start_date = today;
            query.end_date = today;

            // Cập nhật URL với ngày mặc định
            this.props.history.replace({
                pathname: this.props.location.pathname,
                search: qs.stringify(query)
            });
        }

        this.loadData(query);
        this.props.getBranchActive();
    }


    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys })
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        })
    }

    loadData(query) {
        this.setState({
            isLoading: true
        });
        this.props.getRevenueStatistics(query).then(() => {
            this.setState({
                isLoading: false
            })
        }).catch(() => {
            this.setState({
                isLoading: false
            })
        });
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'date') {
            if (value && value.length > 0) {
                query.start_date = moment(value[0]).format('YYYY-MM-DD');
                query.end_date = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.start_date;
                delete query.end_date;
            }
        }

        delete query.date;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    formatCurrency = (value) => {
        if (typeof value !== 'number') return '0 đ'; // hoặc '—' nếu bạn thích dấu rỗng

        return value.toLocaleString('vi-VN', {
            style: 'currency',
            currency: 'VND',
            minimumFractionDigits: 0,
        });
    };

    handleDateChange = (date) => {
        this.setState({ reportDate: date });
        // TODO: gọi API tương ứng với ngày mới nếu cần
    };

    renderColorCard = (icon, label, value, color = '#1890ff', isDanger = false) => (
        <Card
            bordered
            bodyStyle={{
                padding: '10px 12px',
            }}
            style={{
                border: `1px solid ${color}`,
                borderLeft: `3px solid ${color}`,
                minHeight: 72,
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                borderRadius: 6,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 2,
                    }}
                >
                    {React.cloneElement(icon, {
                        style: {
                            fontSize: 18,
                            color,
                            marginRight: 5,
                        }
                    })}

                    <Text
                        strong
                        style={{
                            fontSize: 13,
                            lineHeight: '18px',
                            margin: 0,
                        }}
                    >
                        {label}
                    </Text>
                </div>

                <Text
                    strong
                    type={isDanger ? 'danger' : undefined}
                    style={{
                        fontSize: 16,
                        lineHeight: '20px',
                        margin: 0,
                    }}
                >
                    {this.formatCurrency(value)}
                </Text>
            </div>
        </Card>
    );


    render() {
        var { isLoading } = this.state;
        const { revenue_statistics, branchActiveList, authUser } = this.props;
        var query = qs.parse(this.props.location.search.slice(1));

        return (
            <div>
                <PageTitle routes={routes} title="Báo cáo doanh thu" />
                <div className='mt-2'>
                    <Title level={3}>Báo cáo doanh thu</Title>
                    <div className="mt-2">
                        <Row gutter={16}>
                            <Col className='mb-2' xs={24} md={6}>
                                <FilterableMultiSelect
                                    options={branchActiveList || []}
                                    placeholder="Chọn cơ sở"
                                    parameterName='branch_id'
                                    optionValue="id"
                                    optionLabel="name"
                                />
                            </Col>
                            <Col className='mb-2' xs={24} md={6}>
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Từ ngày', 'đến ngày']}
                                    onChange={(value) => this.onChangeFilter('date', value)}
                                    defaultValue={[query.start_date ? moment(query.start_date, 'YYYY-MM-DD') : null, query.end_date ? moment(query.end_date, 'YYYY-MM-DD') : null]}
                                    className="w-100"
                                />
                            </Col>
                            <Col className='mb-2' xs={24} md={6}>
                                <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        spinning={isLoading}
                        tip="Đang tải dữ liệu..."
                        size="large"
                        style={{ minHeight: 200 }}
                    >
                        <Card style={{ background: '#fff' }}>
                            <Divider orientationMargin={0} orientation="left" style={{ fontSize: 18, fontWeight: 'bold' }}>
                                <LineChartOutlined style={{ fontSize: 20, marginRight: 8 }} />
                                Tổng quan
                            </Divider>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={8}>
                                    {this.renderColorCard(<ShoppingCartOutlined />, 'Doanh số', revenue_statistics.DoanhSo, '#52c41a')}
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    {this.renderColorCard(<DollarOutlined />, 'Doanh thu', revenue_statistics.DoanhThu, '#faad14')}
                                </Col>
                            </Row>

                            <Divider orientationMargin={0} orientation="left" style={{ fontSize: 18, fontWeight: 'bold', marginTop: 40 }}>
                                <UserOutlined style={{ fontSize: 20, marginRight: 8 }} />
                                Khách hàng
                            </Divider>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={8}>
                                    {this.renderColorCard(<UserOutlined />, 'Khách cũ', revenue_statistics.KhachCu, '#722ed1')}
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    {this.renderColorCard(<UserAddOutlined />, 'Khách mới', revenue_statistics.KhachMoi, '#eb2f96')}
                                </Col>
                            </Row>

                            <Divider orientationMargin={0} orientation="left" style={{ fontSize: 18, fontWeight: 'bold', marginTop: 40 }}>
                                <CreditCardOutlined style={{ fontSize: 20, marginRight: 8 }} />
                                Thanh toán
                            </Divider>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={8}>
                                    {this.renderColorCard(<CreditCardOutlined />, 'Tiền mặt', revenue_statistics.TienMat, '#13c2c2')}
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    {this.renderColorCard(<CreditCardOutlined />, 'Chuyển khoản', revenue_statistics.ChuyenKhoan, '#1890ff')}
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    {this.renderColorCard(<CreditCardOutlined />, 'Thẻ', revenue_statistics.ThanhToanThe, '#b37feb')}
                                </Col>
                            </Row>
                            <Divider orientationMargin={0} orientation="left" style={{ fontSize: 18, fontWeight: 'bold', marginTop: 40 }}>
                                <CreditCardOutlined style={{ fontSize: 20, marginRight: 8 }} />
                                Quỹ chi
                            </Divider>

                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={6}>
                                    {this.renderColorCard(
                                        <CreditCardOutlined />,
                                        'Chi tiêu trong kỳ',
                                        revenue_statistics.ChiTrongNgay,
                                        '#f5222d'
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    {this.renderColorCard(
                                        <DollarOutlined />,
                                        'Tổng quỹ đã cấp',
                                        revenue_statistics.TongQuyNhapLuyKe,
                                        '#52c41a'
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    {this.renderColorCard(
                                        <CreditCardOutlined />,
                                        'Tổng đã chi',
                                        revenue_statistics.ChiTieuLuyKe,
                                        '#fa541c'
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    {this.renderColorCard(
                                        <DollarOutlined />,
                                        'Số dư quỹ hiện tại',
                                        revenue_statistics.TonQuyChi,
                                        revenue_statistics.TonQuyChi < 0 ? '#f5222d' : '#1890ff',
                                        revenue_statistics.TonQuyChi < 0
                                    )}
                                </Col>
                            </Row>
                        </Card>
                    </Spin>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        revenue_statistics: state.statisticsReducer.revenue_statistics,
        branchActiveList: state.BranchReducer.branchActiveList,
        authUser: state.auth.authUser
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getRevenueStatistics: (filter) => dispatch(getRevenueStatistics(filter)),
        getBranchActive: () => dispatch(getBranchActive())
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(RevenueReport);
